import {ToolbarType} from "@syncfusion/ej2-react-richtexteditor";

export enum HttpStatusCode {
  CONTINUE = 100,
  SWITCHING_PROTOCOLS = 101,
  PROCESSING = 102,
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  NON_AUTHORITATIVE_INFORMATION = 203,
  NO_CONTENT = 204,
  RESET_CONTENT = 205,
  PARTIAL_CONTENT = 206,
  MULTI_STATUS = 207,
  ALREADY_REPORTED = 208,
  IM_USED = 226,
  MULTIPLE_CHOICES = 300,
  MOVED_PERMANENTLY = 301,
  FOUND = 302,
  SEE_OTHER = 303,
  NOT_MODIFIED = 304,
  USE_PROXY = 305,
  SWITCH_PROXY = 306,
  TEMPORARY_REDIRECT = 307,
  PERMANENT_REDIRECT = 308,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  NOT_ACCEPTABLE = 406,
  PROXY_AUTHENTICATION_REQUIRED = 407,
  REQUEST_TIMEOUT = 408,
  CONFLICT = 409,
  GONE = 410,
  LENGTH_REQUIRED = 411,
  PRECONDITION_FAILED = 412,
  PAYLOAD_TOO_LARGE = 413,
  URI_TOO_LONG = 414,
  UNSUPPORTED_MEDIA_TYPE = 415,
  RANGE_NOT_SATISFIABLE = 416,
  EXPECTATION_FAILED = 417,
  I_AM_A_TEAPOT = 418,
  MISDIRECTED_REQUEST = 421,
  UNPROCESSABLE_ENTITY = 422,
  LOCKED = 423,
  FAILED_DEPENDENCY = 424,
  UPGRADE_REQUIRED = 426,
  PRECONDITION_REQUIRED = 428,
  TOO_MANY_REQUESTS = 429,
  REQUEST_HEADER_FIELDS_TOO_LARGE = 431,
  UNAVAILABLE_FOR_LEGAL_REASONS = 451,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504,
  HTTP_VERSION_NOT_SUPPORTED = 505,
  VARIANT_ALSO_NEGOTIATES = 506,
  INSUFFICIENT_STORAGE = 507,
  LOOP_DETECTED = 508,
  NOT_EXTENDED = 510,
  NETWORK_AUTHENTICATION_REQUIRED = 511,
}

export enum PageNames {
  MAINTENANCE = "Maintenance",
  LOGIN = "Login",
  CHANGEPASSWORD = "Change Password",
  FIRSTTIMELOGIN = "First Time Login",
  FORGOTPASSWORD = "Forgot Password",
  REQUESTACCOUNT = "Request Account",
  USERPROFILE = "User Profile",
  MFAPREFERRED = "MFA Preferred",
  DASHBOARD = "Dashboard",
  ALERTS = "Alerts",
  REPORTS = "Reports",
  SWITCHAPPLICATION = "Switch Application",
  MESSAGES = "Messages",
  FACULTY = "Faculty",
  MASTER_LAYOUT = "Master Layout",
  ADMIN = "Admin",
  RESOURCES = "Resources",
}

export enum AxiosErrorCode {
  ECONNABORTED = "ECONNABORTED",
  ERR_NETWORK = "ERR_NETWORK",
  ERR_BAD_REQUEST = "ERR_BAD_REQUEST",
  ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE",
}

export enum FileExtension {
  FOLDER = "",
  FILE = "File",
  FOLDER_TEXT = "Folder",
  TXT = ".txt",
  ASP = ".asp",
  PHP = ".php",
  PHP5 = ".php5",
  PHT = ".pht",
  JSP = ".jsp",
  EXE = ".exe",
  PDF = ".pdf",
  DOCX = ".docx",
  DOC = ".doc",
  DOT = ".dot",
  XLSX = ".xlsx",
  XLX = ".xlx",
  XLS = ".xls",
  XLT = ".xlt",
  XLA = ".xla",
  XML = ".xml",
  PPTX = ".pptx",
  PPT = ".ppt",
  POT = ".pot",
  PPS = ".pps",
  PPA = ".ppa",
  HTM = ".htm",
  HTML = ".html",
  PHTML = ".phtml",
  SHTML = ".shtml",
  ASA = ".asa",
  CER = ".cer",
  ASAX = ".asax",
  SWF = ".swf",
  XAP = ".xap",
  KAL = ".kal",
  RTF = ".rtf",
  MP3 = ".mp3",
  MP4 = ".mp4",
  XSL = ".xsl",
  ZIP = ".zip",
  WMV = ".wmv",
  MOV = ".mov",
  MPEG = ".mpeg",
  WEBP = ".webp",
  PNG = ".png",
  JPG = ".jpg",
  JPEG = ".jpeg",
  BMP = ".bmp",
  GIF = ".gif",
  TIFF = ".tiff",
  PARTIAL = ".partial",
  OCTET = "",
}

export enum FileMIMEType {
  PDF = "application/pdf",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  DOC = "application/msword",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  XLS = "application/vnd.ms-excel",
  XLA = "application/vnd.ms-excel",
  XLT = "application/vnd.ms-excel",
  PPTX = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  PPT = "application/vnd.ms-powerpoint",
  PPA = "application/vnd.ms-powerpoint",
  PPS = "application/vnd.ms-powerpoint",
  HTML = "text/html",
  XML = "application/rss+xml",
  RTF = "application/rtf",
  TXT = "text/plain",
  MP3 = "audio/mp3",
  MP4 = "video/mp4",
  XSL = "application/xml",
  WMV = "video/x-ms-wmv",
  MOV = "video/quicktime",
  MPEG = "video/mpeg",
  WEBP = "image/webp",
  PNG = "image/png",
  JPG = "image/jpg",
  JPEG = "image/jpeg",
  BMP = "image/bmp",
  GIF = "image/gif",
  TIFF = "image/tiff",
  PARTIAL = "message/partial",
  ZIP = "application/zip",
  OCTET = "application/octet-stream",
}

export enum Faculty {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}

export enum Alerts {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}

export enum CPSMessages {
  LOGOUT_SUCCESSFULLY = "You logged out successfully.",
  ISPIACCESSEMESSAGE = "Authorized users only. Please contact the Administrator for further assistance.",
  SESSION_EXPIRED = "Your login session expired.",
  LOGOUT_ANOTHER_SYSTEM = "You have logged into another system",
  EXCEPTION_HANDLER_TITLE = "An unexpected error occurred in the application.",
  PASSWORD_MEET = "Your password must meet the following criteria:",
  SOMETHING_WENT_WRONG = "Some thing went wrong.",
  OLD_NEW_NOT_MATCH = "Old password and new password are same enter different new password.",
  PASSWORD_NOT_MATCH = "Password do not match.",
  PLEASE_SELECT_ONE_CHECKBOX = "Please select at least one checkbox.",
  SELECT_FIRST_SEQURITY_QUESTION = "Please select the first security question.",
  PLEASE_ENTER_USER_ID = "Please enter the User Id.",
  FIRST_QUESTION_ANSWER = "Please enter the answer for the first security question.",
  SECOND_QUESTION_ANSWER = "Please enter the answer for the second security question.",
  SELECT_SECOND_SEQURITY_QUESTION = "Please select the second security question.",
  SELECTPROFILEVALIDATION = "Please select a profile.",
  PLEASE_ENTER_PASSWORD = "Please enter the password.",
  PLEASE_REENTER_PASSOWRD = "Please re-enter the password.",
  ENTER_OLD_PASSWORD = "Please enter the old password.",
  ENTER_NEW_PASSWORD = "Please enter the new password.",
  ENTERFIRSTNAME = "Please enter the first name.",
  ENTERLASTNAME = "Please enter the last name.",
  ENTERTELENUM = "Please enter the telephone number.",
  ENTERVALIDTELE = "Please enter a Valid Telephone Number.",
  ENTEREMAILID = "Please enter the email address.",
  ENTERVALIDEMAIL = "Please enter a valid email address.",
  ENTERCOMPANY = "Please enter the company name.",
  ENTERSUPERVISOR = "Please enter the supervisor name.",
  ENTERSUPERVISOREMAIL = "Please enter the supervisor email id.",
  ENTERVALIDSUPERVISOREMAIL = "Please enter valid supervisor email address.",
  ENTERSUPERVISORPHONE = "Please enter the supervisor phone.",
  ENTERVALIDSUPERVISORNUM = "Please enter a valid Supervisor Telephone Number.",
  BUSINESSJUSTI = "Please enter the business justification.",
  BUSINESSJUSTIMINCHAR = "Business justification must be at least 35 characters.",
  SELECTCAPTCHA = "Please select the captcha.",
  ENTER_COST_CENTER_NAME = "Please enter cost center.",
  PASSWORD_CRITERIA = "Must contain 8-25 characters, one uppercase, one lowercase, one number, and one special character.",
  ANNOUNCEMENTSUCCESS = "The announcement is successfully removed.",
  DASHBOARDALERTNODATA = "There are no Alerts.",
  RESOURCENODATA = "No Resource content exists in this folder",
  DASHBOARDMSGNODATA = "There are no messages.",
  DUPLICATE_TAB_ALERT = "Can't open multiple instances of this site.",
  INTERNAL_SERVER_ERROR = "Service unavailable. Please try after sometime.",
  SERVICE_NOT_FOUND = "The Resources you are trying to access does not exist. Please refresh the page and try again. If the issue persists, kindly contact system adminitsrator.",
  SYSTEM_ERROR = "Some thing went wrong.",
  TIMEOUT_ERROR = "We apologize, but it seems that our server is currently experiencing a delay in responding to your request. Please refresh the page and try again. If the issue persists, kindly wait for a few moments before attempting again. Thank you for your patience.",
  NETWORK_ERROR = "Network Error.",
  REQ_EXCEPTION_TEXT = "To request an exception please click on the below link.",
  PLEASE_FILL_OTP = "Please enter OTP.",
  LINK_INACTIVE = "Reset password link has expired.",
  CONTACT_SUPPORT = "Error: Please try again or contact support 866-277-6024.",
}

export enum CPSNumbers {
  MINUS_TWO = -2,
  MINUS_ONE = -1,
  ZERO = 0,
  ONE = 1,
  ONE_POINT_FIVE = 1.5,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
  TEN = 10,
  ELEVEN = 11,
  TWELVE = 12,
  THIRTEEN = 13,
  FOURTEEN = 14,
  FIFTEEN = 15,
  EIGHTEEN = 18,
  EIGHTY_SEVEN = 87,
  NINETY_NINE = 99,
  TWENTY_THREE = 23,
  FIVEHUNDRED = 500,
  TWENTY_FOUR = 24,
  TWENTY_FIVE = 25,
  ACTIVITY_TYPE_ID_MINUS_ONE = -1,
  ACTIVITY_TYPE_ID_THREE = 3,
  SIXTEEN = 16,
  SEVEENTEEN = 17,
  ACTIVITIY_TYPE_ID_FDA = 2,
  ACTION_TYPE_ID_ONE = 1,
  ACTION_TYPE_ID_TWO = 2,
  ACTION_TYPE_ID_SIX = 6,
  ACTION_TYPE_ID_SEVEN = 7,
  ACTION_TYPE_ID_EIGHT = 8,
  ACTION_TYPE_ID_NINE = 9,
  ACTION_TYPE_ID_TEN = 10,
  ACTION_TYPE_ID_ELEVEN = 11,
  ACTION_TYPE_ID_THIRDTEEN = 13,
  ACTION_TYPE_ID_SEVENTEEN = 17,
  ACTION_TYPE_ID_EIGHTTEEN = 18,
  THOUSAND_FOURTY_THREE = 10043,
  THOUSAND_FOURTY_SEVEN = 10047,
  TWO_HUNDRED_NINTEEN = 219,
  TWO_HUNDRED_TWENTY_TWO = 222,
  TWO_HUNDRED_SEVEN = 207,
  TEN_THOUSAND_TWO_NINTY_NINE = 10299,
  TEN_THOUSAND_ONE_FIFTY = 10150,
  SIXTY = 60,
  THOUSAND_FOUR = 1004,
  TWO_HUNDRED = 200,
  TWENTY_ONE = 21,
}

export enum ADActivityTypes {
  Advising_Consulting = 1,
  FDA_Regulated_Program = 2,
  Discovery_Research_Medical_Research = 3,
}

export enum CPSMessageCodes {
  ZERO = 0,
  SIX_SEVEN_ONE_FOUR_SEVEN_ZERO_FOUR_SIX = 67147046,
  NOMINATE_VENUE_DIALOG = "54501,54509,54504,54507,54505,40066,54511,54516",
  FACULTY_BASIC_SEARCH_RESULT = "47816,49831,49830,50105,40052",
  FACULTY_ADVANCE_SEARCH = "47816,49831,49830,40052,50105,49807,46273,42533,42532,50101,5193614,5193615,5193616,519366,519369,519368,5193617,519367,5193613,519365,25196251,251956,25196250,5193630",
  FACULTY_PROFILE_CODES = "11898,40133,550003,550009,550016,550011,42414,31506,53040,42547,47202,5273705,5273702,7453902",
  FACULTY_CONRACTS_TAB = "67147022",
  ADD_TRAININGINFO_SERVER_MESSAGES = "46266,46267,22511,46226,40024,46312,49232",
  ADD_TEXT_MESSAGE_ALERT_DIALOG = "70501,70502,85524,42499",
  ADD_NON_HCP_AND_PATIEND = "496222,496226,44132,46308,46309,46256,46257,49830,49832,46258,49831,49809,46279,12377,12546,12573,49653,46310,12543,22501,26251",
  ADD_EDIT_AFFILIATION_MESSAGES = "54517",
  ADD_EDIT_LICENSE_MESSAGES = "42402,42403,42404,42405,42415,42413,42413,47807,47809",
  UPLOAD_LICENSE_MESSAGES = "42413,42414,42419,25196269",
  ADD_EDIT_VENUE_CATERER_MESSAGES = "54501,54509,54504,54507,54505,54511,54527,54502,54503,54506,40066,54508,54532,47511,54525,54537,54519,54529,54530,54531,53052,53051",
  TAXFORM_1099 = "521611,521612,521614,521613,521618,521617,521615,521616",
  HCP_CONTACT_NOTE_MESSAGES = "42540,42544,42541",
  ACTIVITY_MAP_MESSAGES = "41921,40014,41925,41926",
  ACTIVITY_STATS_MESSAGES = "41921,40014,41925,41926",
  SEARCH_VENUE_CATERER_MESSAGES = "54517,54518",
  ADD_EDIT_ADDRESS_DIALOG = "42202,12378,46268,41904,46271,46270,40066,44106,46273,12384,600112,46274,46275,12551,44108,44115,42331,42334,42333,47511",
  ADD_EDIT_SBINDICATOR_DIALOG = "42321,42322,42336,42326,42327,12373,12382,46266,46267",
  FACULTY_REQUEST_PROFILE_DETAIL = "67147057,46256,49650,46257,46258,46259,46261,46263,49656,49657,49809,49830,49831,49832,49802,46265,46266,46267",
  ADD_EDIT_PROFILE_SERVER_MESSAGES = "46266,46267,70507,6648505,6648502,46256,46257,46258,49809,49830,49831,46265,49825,49826,49802,49651,49652,42318,49650,46259,42201,70507,6768801,6768802,7177313,717738,717739,42488,6702009,6702008,42319,42320,6768806,42493,42492,46272,42490",
  ADD_ADD_ORG_CONTACT_DIALOG_SERVER_MESSAGES = "46257,46258,44108,42489,42490",
  FACULTY_REQUEST_CONTACT_INFO_SERVER_MESSAGES = "496226,46279,12558,4330713,12377,12546,12573,22501,49653,496225,496222",
  FACULTY_REQUEST_CLIENT_SPONSOR_INFO_SERVER_MESSAGES = "44132,46308,46309,46310,26251,12543,22501",
  ADD_EDIT_FACULTY_TIERING_SERVER_MESSAGES = "140501,42497,140502,140503,140504,140505,140506,41882,519361,140534",
  ADD_MULTIPLE_FACULTY_SERVER_MESSAGES = "44132,42502,42503,42504,46310,12543,42505",
  FACULTY_CV_BIO_PICINFORMATION_SERVER_MESSAGES = "49233,49236,49238,49239,860137,49232",
  FACULTY_PPQ_ADVANCE_SEARCH_SERVER_MESSAGES = "49654,5193611,5193612",
  LICENSE_DELETE_MESSAGE = "67147056",
  FACULTY_ALLOCATION = "10736,10534,40516,40517,40518,10537,10538,10568,10569,10754,10737,10534,10531,10732,10737,10569,10759,36266,46267,46266",
  ADD_EDIT_EXPENSES_MESSAGES = "42491,40133,17602",
  REQUEST_FOR_FUNDS_MESSAGES = "10541,10755,10545,10543,10534,10735,10542,10571,10755,10535",
  ADD_NOTES_MESSAGES = "10761",
  BICOMPLIMIT = "130026",
  ACTIVITY_SERIES = "41816,41817,40133",
  ALERT_PREFERENCES_SCREEN = "42600,40020,41903,49804,42601,42602,42603",
  CONTENT_MANAGEMENT_FOLDER = "130501,130579",
  CONTENT_MANAGEMENT_FILE_DELETE = "85574",
  CONTENT_MANAGEMENT_FILE_EDIT = "85570,45138,85570,85575,85573",
  CONTACT_NOTE_TYPE_CONFIG = "49111,49112,49113,49544",
  FACULTY_KEY_CHANGE = "41814,41815,41972,40255,41824",
  ADMIN_SERVER_MESSAGES = "10534,31801,31803,80220,80219,80221,41851,41852,41827,521701,521702,521705,521703,521706,521707,67147058,67147058,80276,521611,521614,521613,521620,86010,47519,49831,49830",
  UPDATE_DOC_ON_FILE = "41813,40133",
  COST_CENTER_INSERT = "41810,481004,86127",
  UPDATE_IO = "41811,41828,11889,41812",
  TAX_TEXT_CONFIGURATION = "25196301",
  ADD_NEW_AFFILIATION_CONTACT_NOTE = "41960,31834,80203,54519",
  ADD_NEW_ENTITY_DIALOG = "12192,12187,12195,80276",
  EDIT_SCREENING = "12189",
  ADD_REMOVE_BRANDS = "41851,41852,41827",
  ADD_EDIT_TOOLTIP_DIALOG = "67147069,6598532",
  ADD_EDIT_COMMENT_DIALOG = "659851,659852,67147070",
  ARF_MESSAGES = "67147060,6598513,6598514,67147061,67147062,67147063,67147064,67147065,67147066,67147067,67147068",
  SUPPLIER_BRAND = "46584,46585,46574,46575,46576,41819,44532,44533,80271,46583,41941,41940,46580,46582,41942,41880,41933,130570,130574",
  FIELD_ALIGNMENT_MAPPING = "41839,50117,50118,41831,41832,41837,41833,41834,41838,41835,41836,41840",
  MFA_PREFERRED_MESSAGES = "7088008,7088016,7088017,7088011,7088023",
  ACCOUNT_LOCKED_DUE_TO_FAILED_ATTEMPTS = "12154",
  REQUEST_FORM_CONFIGURATION = "67147065,67147071,6598513,6598514,67147073,67147066,67147074,67147072,67147068,5760304",
  REQUEST_FORM_SUBMIT = "5760303,80132,5760305",
  MY_SCHEDULED_REPORTS_MESSAGES = "7580004,7580009,7580011,7580013,7580015,7580017,7580019",
  REPORTS_CRITERIA_MESSAGES = "7580005,7580017,7580019,7580022,7580023,7580024,7580025,7580026,7580027,7580028",
  ADVISING_CENTRAL_MEMBERS_MESSAGES = "41851,41852,41827,860418",
  ADD_COMMENTS_MESSAGES = "46610",
  INDIVIDUAL_PAYMENT_MESSAGES = "41960",
  ENTER_INFORMATION_MESSAGE = "40289",
  CREDENTIALS_FOR_PAYMENT_LIMITS_MESSAGES = "41851,41852,41827,860414",
  BUSINESS_AREA_MESSAGES = "40209,40210,41827,40289,40208",
  THERAPEUTIC_AREA_MESSAGES = "41851,41852,41827,49516,49517",
  INDIVIDUAL_PAYMENTS_MESSAGES = "860401,85577,860402,860403,860408,860404,860443,454013,860428,860442,860430,860429,860426,860427",
  DISTRICT_TERRITORY_MANAGER_MESSAGES = "6505523,6505524,86126,6505514",
  UPDATE_APPROVERS_MESSAGES = "41821,41822,41938,40311,40312,40314,41953,41954,41955,40072,40313,80140,8014180143,80144,80149,80150,80151,80152,80153,80154,41821,80176,80232,41950,41951,41952,40133,44132",
  SUPPLIER_LIST = "41823,31840,31842,41897,41898,41899,41900,41901,41902,41903,41901,41904,41905,41906,51100,51102,51101,51103,41944,41981,80058,80198,41990,41991,7088001,32704",
  BRAND_APPROVERS = "41851,41852,41827,41800",
  APRROVERS_ASSIGNMENT = "44533,44532,46544,41978,46539,46538",
  SPP_NOTIFICATION = "67147058,42541",
  SPP_ANNUAL_NOTIFICATION_TRIGGER = "67147082,67147083",
  ASSIGNER_ALIGNMENT = "80276,41851,41852,80274,80275,80263,46551",
  ADD_EDIT_BRAND_SUBBRAND_LOGO = "481005,67147078,481006,67147079,67147077,481004,67147080,67147081",
  ADD_EDIT_BRAND_SUBBRAND = "31835,31836,317012,5761300,5761301,317011,317015,317017,317014,317015,49506,49507,49508,49509,860410,49518,41969,41826,46223,40077,31834",
  FACULTY_SELECTIO_RULES = "80264,80265,80266,80268,80270,80271,80269,80267",
  ALIGNMENT_LIMITS = "80263,80258,80259,80260",
  TOPIC_TRAINING_REQUIREMENT = "49511,49512,49538,41806,80044,11103,31502,49533,49534,41806,41807,49513,49542,49514,49531,49543,41880,41881,49549,251998,67147086,251999,49532,49540,47060,41888,49535,49545,49547,49536,49546,49548,49537,41883,41884,41885,49539,49544,11102,11101",
  CONTRACT_MANAGEMENT = "67147092,67147091,41970,46314,46315,46231,46229,46227,46228,46233,46242,46302,67147093,46234,46232,46243,260004,46254,40133",
  CONTRACT_HISTORY = "46253,46227,46228,46254,46255,46252,46234,46302,46251,40133",
  CONTRACT_MANAGEMENT_UPLOAD = "67147094,67147095,80024",
  TOPIC_TRAINING_ADMIN = "41965,41992,41963,40303,40304,41994,41993,41964,41908,41909,41968,41962,41966,41965,41967,53040,41969,41817,40133,40024,41830,10757,42305,31507",
  CREDENTIALS_SPECIALTY = "41962,7387717,7387718,7387715,7387716",
  USER_LIST = "22005",
  CONTRACT_TEMPLATE_MESSAGES = "41851,41852,41827,41914,67147090,80023,41911,41912,41915,41918,860132,41939,6702001,41913,41914,41917,41919,41920,41921,41922,41882,41923,43217,6511601,41916",
  PARTICIPATION_MESSAGES = "52223",
  EXCLUDED_APPROVERS = "46234",
  FR_CONTENT_ASSOCIATION = "49831,49830,47424,47526,27006,47415,47417,47423,41980",
  SEND_EMAIL = "46552",
  APPROVAL_REQUIRED = "260005",
  ANNOUNCEMENT_EDITOR = "67147097",
  ADD_EDIT_ANNOUNCEMENT_EDITOR = "42326,550891,550892,41910,41907,41971,45138,41989,67147098",
  STATE_GUIDELINES = "41843,41844,317005,317004,41847,41848,41841,41842,317001,41845,41969,41846,317002",
  FR_CONTENT_CONFIG = "47423,47817,47425,47805,47806,47801,47817,47426,47804,27101",
  ADD_EDIT_EMAIL_NOTIFICATION_MESSAGES = "41851,41852,41827,85556,85557,525603,525601,525602,525604,525605,37006,37007,85551,46553,85558,41915,80076,85552,85559,85528,80160,48004,80017,41889,80198,85553,42600,40033,85546,85547,85548,85549,85550,85555,378100",
  MERGEFIELD_MESSAGES = "85560",
  MERGE_FIELD_TABLE_MESSAGES = "85562,85563,85564,85565",
  SPECIALTY_GROUP_MESSAGE = "46570,46571,46572,67147100",
  CONTENT_MANAGEMENT_PERMISSION_SUPPLIER = "130572,130573,47416,47813,41827,130571,130570,130574,130575,130576,130577,130582,130564,130568,130562,130566,130563,130567,130565,130569,130584",
  USER_MANAGEMENT = "44101",
  ADMIN_USER_GROUP = "80160,80161,80162,80163,80164,80165,80166,80167,80168,80169,80170,80172,80173,80174,80175,80177,80180",
  TEXT_MESSAGE_ALERT_MESSAGES = "41851,41852,41827,85500,85501,85528,85502",
  AI_COMPLIANCE_QUEUE = "69112111,69112112",
  SEND_ALERT_CONFIGURATION_MESSAGES = "85506,85509,85520,85521,85522,85513,85515,85516,85517,85518,85519",
  CHANGE_ACTIVITY_DESCRIPTION_MESSAGES = "41817,40133,41819,80131,31838",
  ADD_USER_GROUP_DEVISION_MAPPING_RULE_MESSAGES = "41851,41852,41827,489812,41980,80274",
  AICOMPLIANCEFINDING_EDITOR = "67147097,69112122,47424,49658",
  AICOMPLIANCEFINDING_FLAG_EDITOR = "67147070,67147102,31834,46610,69112123,69112124,659853",
  ADD_USER_GROUP_DEVISION_MAPPING_CONTACT_NOTE = "41960,31834,80203,54519",
  INVITATION_TEMPLATE = "41965,6857511,6857509,49511,49512,80009,80010,80012,80013,80015,80016,80018,80019,31505,80001,80023,31506,6857519,80020,80024,7331903,7331901,7331902,80002,80003,80004,49514,80008,80011,80014,80017,41969,80020,80022,80025,6857510,44132,",
  GROUPING_CONFIGURATION = "80250,41851,41852,80255,80256,80257,80247,80248,41876,80251,80252,80249,80254,80253",
  REP_EVALUATION_CONFIG = "41851,41852,41827,41960,860150,,860151,860150,67147099",
  USER_MANAGEMENT_ACCOUNTS = "860041,41920,44108,44109,44116,7088020,41979,41978,41980,44104,44105,41988,41973,44106,44107,67147101,41997,860041,44110,44111,44139,44113,44112,42000,41999,41998,41975,41976,130588",
  USER_MANAGEMENT_COMMENTS = "32703,32704,424761",
  USER_MANAGEMENT_MFA_POPUP = "7088016",
  USER_MANAGEMENT_FR_SEARCH_POPUP = "49830,49831,54517,41994",
  USER_MANAGEMENT_SALES_FORCE_INFO_POPUP = "48091,130589",
  USER_MANAGEMENT_ASSIGN_USER_GROUP_POPUP = "41979,41978,41980,5193640,48091,44110,44111,44113,44139,44112,44138,130586,130587,130588,130589",
  USER_MANAGEMENT_PROFILE_TAB = "44111,44113,44139,44112,44138,130586,130587,130588,130589",
  BUDGET_EXEMPTION = "41851,41852,41827,41802,41803",
  ACTIVITY_ASSIGNMENT_MESSAGES = "46584,44532,41807,44533,54402,54401,46537,46524,80264,46526,80245,41978,46531,41935,40023,80271,40036,46530",
  ACTIVITY_ASSIGNMENT_FACULTY_SEARCH_RESULT = "47816,46590,",
  EXPENSE_MANAGEMENT = "41960,41889,41888,41880,41881,41882",
  ACTIVITY_AUTO_CANCEL_MESSAGES = "10531,10532,41855,41856,42522,42523,80199,80200,80197,80198,17321,48004,41880,49549,80185,80188,80186,80187,80189,80237,41881",
  ADMIN_BUSINESS_JUSTIFICATION_MESSAGES = "10531,10532,80201,80202,80191,80192,80197,40024,41880,41881,49549",
  ACTIVITY_DESCRIPTION_MESSAGECODES = "41851,41852,80111,80132,80072,80074,80073,80058,480680,80076,25196294,25196295,25196296,80059,25196267,80061,7481502,80062,80063,80064,80065,80066,80067,80091,80068,17322,25196278,480689,480690,480691,80069,80071,80070,80098,80077,80078,80080,80079,80082,80083,80084,80085,80086,80087,80060,80088,80241,80242,80243,2699110,2699111,6702004,25196113,25196121,25196114,25196115,25196112,25196116,25196117,25196118,6957511,25196119,25196120,6173801,80094,85544,80089,80090,80244,80204,80205,80100,3524811,25196301,7481501,67147103,67147104,67147105,67147106,67147107,6173804,6173805,6173806,80073,80075,3524810,41827",
  ACTIVITY_DESCRIPTION_WORKFLOW_MESSAGECODES = "80097",
  HONORARIUM_MANAGEMENT_ADV = "41930,41851,41852,41827,41855,41856,41854,41853,41857,41858,41859,41860,41861,85530,41863,46263,41864,41865,41866,41867,41868,41934",
  FACULTY_SELECTION = "317018,41981,85577,46236,85578,317010,317013",
  ATTENDEE_PROGRAM_BLOCK_MESSAGES = "25196282,41883,41885,41851,41852,41827,41851,41852,41827,41851,41852,41827,41960,41878,41880,41881,41882,41883,41884,41885,25196286,41888,25196290,25196284,41889,25196287,25196292,25196286,25196292,25196286",
  ATTENDEE_PROGRAM_CONTACT_NOTES_MESSAGES = "41960",
  FACULTY_SELECTION_CONTACT_NOTE = "41960",
  TIER_BRAND_MAPPING = "41882,41930,41851,41852,41827,41915,42497,140505,140506,41882,41889,",
  MEDICAL_TIER_ADMIN = "5193618,5193627,5193625,5193619,5193621",
  AICOMPLIANCERULE_CONFIGURATION_EDITOR = "80264,46226,69112125,69112126",
  LIST_ACTIVITYRULE_MESSAGES = "140410,41885,41883,41851,41852,41827,80040,41891,41892,46611,67147109,44135,41893,41894,41878,41879,41880,41881,41883,41884,41886,41887,41888,260001,41889,25196300,41890,46611,80179,80203,41959,260003",
  SEARCH_SALES_ORG_RESTRICTIONS_MESSAGES = "44137,44134,41895",
  SEARCH_SALES_ACCESS_TRAINING_MESSAGES = "44137,40303,46258,40304,46612,46612,80043,46613,80042",
  ACTIVITY_RULE_COMMENT_MESSAGES = "41960,46610",
  HONORARIUM_TRAVEL_MESSAGES = "49549",
  ADD_HONORARIUM_TRAVEL_MESSAGES = "49549,41851,41852,41827,67147114,67147110,41880,41881,49549,67147111,67147112,480663,67147113,67147115,67147114,67147116",
  HONORARIUM_ADMIN_MESSAGES = "41930",
  ADD_HONORARIUM_ADMIN_MESSAGES = "85545,80117,85533,85534,85535,85536,85537,85545,85538,85539",
  ADD_HONORARIUM_ADMIN_TIER_MESSAGES = "41851,41852,41827,85531,140505,140506,41882,67147100,85532,52448,",
  HONORARIUM_MANAGEMENT_FDA = "41930,41851,41852,41827,41855,41869,41873,41870,41871,41872,85530,41875,46263,41876,41877,41934",
  HONORARIUM_MANAGEMENT_MEDICAL = "41930,41851,41852,41827,41869,41873,41870,41871,41872,85530,41875,46263,41876,41877,41934",
  PAYMENT_CONFIGURATION = "80117,80129,80133,80182,80184,80119,80120,80121,80122,80123,80207,80208,80209,80210,80126,80128,80183,41851,41852,41827",
}

export enum CPSConstants {
  FONT_FAMILY = "Montserrat",
  IVALID_DATE = "0001-01-01T00:00:00",
  CPS_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSS",
  CPS_DAY_MONTH_YEAR_TIME = "dd/MM/yyyy hh:mm:ss aa",
  CPS_MONTH_DAY_YEAR_TIME = "MM/DD/YYYY hh:mm:ss A",
  CPS_MONTH_DAY_YEAR_HH_MM_TIME = "MM/DD/YYYY hh:mm A",
  CPS_MONTH_DAY_YEAR_HH_MM_SS_AMPM = "MM/dd/yyyy hh:mm:ss aa",
  MONTH_DAY_YEAR_TIME = "MM/dd/yyyy hh:mm a",
  CPS_MONTH_SLASH_DAY_YEAR = "M/dd/yyyy",
  MUI_STACK_LOGINFORM_SPACE = 0.1,
  SUCCESSMESSAGE_EIGHTSIXFOURFIVE = 860045,
  SUCCESS_MESSAGE_CODE = 0,
  FIVEHUNDRED = 500,
  MIN_LENGTH_THIRTY_FIVE = 35,
  MAX_LENGTH_TWO_FOURTY = 240,
  MAX_LENGTH_TWO_FIFTY = 250,
  MAX_LENGTH_TWENTY_FIVE = 25,
  TEXT_ROW = 4,
  MAX_LENGTH_TWO = 2,
  MAX_LENGTH_ONE_FIFTY = 150,
  MAX_LENGTH_HUNDRED = 100,
  MAX_LENGTH_TWO_HUNDRED = 200,
  MAX_LENGTH_SIX = 6,
  MAX_LENGTH_SEVEN = 7,
  MAX_LENGTH_EIGHT = 8,
  MAX_LENGTH_THIRTY_FIVE = 35,
  MAX_LENGTH_THOUSAND = 1000,
  MAX_LENGTH_FOURTY = 40,
  MAX_LENGTH_THREE_HUNDRED = 300,
  MAX_LENGTH_US_TELEPHONE = 14,
  MUI_TEXTFIELD_SIZE = 9,
  MSG_SET_TIMEOUT = 10000,
  MUI_OTPSCREEN_SIZE = 11,
  MAX_LENGTH_FIVE = 5,
  MAX_LENGTH_FOUR = 4,
  MAX_LENGTH_THREE = 3,
  MAX_LENGTH_TWELEVE = 12,
  MAX_LENGTH_FOURTEEN = 14,
  MAX_LENGTH_FIFTHTEEN = 15,
  MAX_LENGTH_TWENTY = 20,
  MAX_LENGTH_THIRTY = 30,
  MAX_LENGTH_THIRTYFIVE = 35,
  MAX_LENGTH_FIFTY = 50,
  MAX_LENGTH_FIFTY_ONE = 51,
  MAX_LENGTH_TEN = 10,
  MAX_LENGTH_NINE = 9,
  MAX_LENGTH_FIVE_HUNDRED = 500,
  MAX_LENGTH_FOUR_THOUSAND = 4000,
  MAX_LENGTH_THREE_THOUSAND = 3000,
  MAX_LENGTH_TWO_THOUSAND = 2000,
  MAX_LENGTH_FIVE_HUNDRED_TWELVE = 512,
  MAX_LENGTH_ELEVEN = 11,
  MAX_LENGTH_TWO_HUNDRED_FIFTYFIVE = 255,
  MAX_LENGTH_SEVENTYFIVE = 75,
  FACULTY_CONTACT_NOTE_CONTENT_LIMIT = 100000,
  FORM_ROW_SPACING = 3,
  FORM_COLUMN_SPACING = 2.5,
  API_TIMEOUT = 120000,
  CPS_TL_CRM_REPORT = 307,
  DEFAULT_COLUMN_SORT = "product",
  GRID_ROW_HEIGHT = 25,
  LARGEST_MEETING_ROOMS_CONSTANT = 99999,
  APPROVAL_ALERT_ID = 37,
  PLEASESELECTPROFILE = "Select Profile",
  PLEASE_SELECT = "Please select",
  UNAUTH_QUERY_STRING = "/login?logoutcase=1",
  UNAUTH_QUERY_STRING_LOGOUT_SYSTEM = "/login?logoutcase=2",
  UNAUTH_QUERY_STRING_SESSION = "/login?logoutcase=3",
  GOOGLERECPATCHAWHEN = "gReCaptchaResponse",
  PW_ONLY = "pwonly",
  MAX_FACULTY_KEY = "2147483647",
  FORMHEADERLOGOWIDTH = "34rem",
  FORMBGCOLOR = "#FFFFFF",
  BGHEIGHT = "100vh",
  LOGINFORMBORDERRADIUS = "0.5rem",
  LOGINFORMWIDTH = "375px",
  LOGINFORMHEIGHT = "38rem",
  LOGINSECONDFORMHEIGHT = "4.5rem",
  FORMWIDTH = "375px",
  STANDARDCOLOR = "#040D36",
  BUTTONBGCOLOR = "#275dc6",
  FONTWEIGHT = "500",
  FONTREMTITLE = "1.5rem",
  FONTREMHEAD = "1.2rem",
  FONTREMTEXT = "1rem",
  DEFAULTCOUNTRYCODE = 1,
  COLUMN_HEADER_NAME_ACTIONS = "Actions",
  COLUMN_HEADER_NAME_ACTION = "Action",
  UPTOTWOFIFTYCHARS = "Business justification minimum 35 characters and up to 250 characters.",
  APPENDVIEWOWNERSHIP = "alerts/orfalertsubmitterstatus",
  MAX_THOUSAND_CHARACTER = "max 1000 characters allowed",
  MAILING_1099_TOOLTIP = "1099 Mailing indicator is available, when a W9 address is added. When checked for any address type, it will use that physical address to print and mail the 1099 form.",
  QUICK_INFO = "QuickInfo",
  FDA_REGULATED = "FDA-Regulated",
  TYPEOF_STRING = "string",
  // Reports module
  PAGE = 0,
  PAGE_SIZE = 10,
  ALERT_TYPE = "DMC Compliance Alert",
  BUDGET_APPROVE_TITLE = "Budget Approval Reason",
  UNDER_REVIEW_RECORD = "Under Review Record",
  APPROVE_TITLE = "Approval Reason",
  APPROVE_DESCRIPTION = "Enter reason for Approving the alert",
  APPROVE_DESCRIPTION_OPTIONAL = "Enter reason for approving. (Note: Reason for approval is optional)",
  DENYING_ALERT = "Enter reason for Denying the alert",
  FACULTY_SCREEN_ALERT = "Faculty Screening Alerts",
  DENY_TITLE = "Denial Reason",
  DENY_DESCRIPTION = "Enter reason for denying the approval",
  ONHOLD_TITLE = "Holding Reason",
  ONHOLD_DESCRIPTION = "Enter reason for Holding the alert",
  SMALL_ALL = "all",
  CAPS_ALL = "All",
  CAPS_ADD = "ADD",
  CAPS_TRIGGERPPQ = "TRIGGERPPQ",
  ADD = "add",
  EDIT = "edit",
  FORM_TEXT = "form",
  OPEN_TEXT = "open",
  BACKDROPCLICK = "backdropClick",
  APPROVER_1 = "Approver 1",
  APPROVER_2 = "Approver 2",
  CHAR_LIMIT_TO_REASON = 20,
  CHARACTER_LIMIT = 20,
  ACTIVITY_TYPE_ID = 3,
  ALERT_TYPE_ID = 10568,
  NONHCP_SUBMENU_ID = 2230,
  PATIENT_AND_CAREGIVER_SUBMENU_ID = 2229,
  PATIENT_AND_CAREGIVER_SUBMENU = "Add Patient/Caregiver",
  NONHCP_SUBMENU = "Add Non-HCP",
  PATIENT_EDIT_CAREGIVER_SUBMENU = "Edit Patient/Caregiver",
  NONHCP_EDIT_SUBMENU = "Edit Non-HCP",
  PATIENT_AND_CAREGIVER_SUBMENU_TEXT = "Patient/Caregiver",
  NONHCP_SUBMENU_TEXT = "Non-HCP",
  TEXTAREA_ROW_COLUMN = 3,
  TEXTAREA_MIN_ROW_COLUMN = 2,
  FACULTY_ADD_CONFIRMATION_TEXT = "Are you sure you want to continue with the request to add faculty?",
  ADD_MULTIPLE_FACULTY_TIP_TEXT = "Tip: Row #1 of the spreadsheet (in green below) displays the names of the fields for you to enter",
  FILE_NAME = "MultipleFacultyRequest.xlsx",
  BROWSE_IMPORT_FILE_TEXT = "Browse And Import The File Into CPS System",
  HOME = "Home",
  APPROVERS = "Approvers",
  DOWNLOAD_SPREADSHEET = "Download Spreadsheet",
  ADD_MULTIPLE_FACULTY = "Add Multiple Faculty",
  POPUP = "popup",
  POPUP_DIRECT = "direct",
  GENERAL_PROFILE_HEADING = "General Profile",
  FACULTY = "faculty",
  PROFILE = "profile",
  FIELDNAME = "[FieldName]",
  CONFERENCE_DIAL_NUMBER = "Conference Dial-In Number",
  THIS_INFORMATION_REQUIRED = "This information is required.",
  VALID_EMAIL_REQUIRED = "Please enter valid email address.",
  VALID_CONTACT_NUMBER_REQUIRED = "Please enter valid contact number.",
  VALID_DATE_REQUIRED = "Please enter valid date.",
  DELETE = "delete",
  SYNCFUSIONREQUESTTYPE = "ContentLoaded",
  SCHEDULED = "scheduled",
  OCCURED = "occurred",
  TOTAL = "total",
  CANCELLED = "cancelled",
  PUBLISH = "Publish",
  TAXFORMDELETE = "Delete",
  DATEFORMAT = "MM/dd/yyyy",
  DATEWITHTIMEFORMAT = "M/D/YYYY h:mm A",
  ITEM_HEIGHT = 48,
  ITEM_PADDING_TOP = 8,
  CAPS_REMOVE = "REMOVE",
  PROFILE_DATA_VERIFICATION_TEXT = "<p><b>Off:</b> The manual override is not applicable; the Faculty will be included in the Data Verification process once they have met the verification criteria.<br><br><b>Exclude from the process:</b> The DV overlay will not display for this Faculty. Change back to 'Off' to remove the exclusion and start the process when the necessary criteria are met.<br><br><b>Trigger Data Verification:</b> Force the DV to display regardless of the Faculty meeting the necessary criteria. The DV will apply for the current calendar year only. The trigger is then removed starting January 1st.</p>",
  SUPRESS_EMAIL_NOTIFICATION = "This individual will not be copied on any applicable system-generated emails to the faculty.",
  FACULTY_DATA_VERIFICATION_CRITERIA = "Faculty Data Verification Criteria",
  FACULTY_DATA_VERIFICATION_BLOCK1 = "The following settings and criteria are considered to have the Faculty Data Verification overlay screens shown to the faculty member when they either log on to the FR website or FR App.",
  FACULTY_DATA_VERIFICATION_BLOCK2_1 = "1. Set a start date in the system metadata to kick off the process",
  FACULTY_DATA_VERIFICATION_BLOCK2_2 = "2. When the faculty member logs in to the system, and if one or more of the eligibility criteria below is met",
  FACULTY_DATA_VERIFICATION_CRITERIA1 = "New Faculty added in that current calendar year via the Faculty > Add Faculty after Sponsor 1 & 2 approves, and the faculty status is 'Restricted To Be Screened'.",
  FACULTY_DATA_VERIFICATION_CRITERIA2 = "New Faculty is added in that <b>current calendar<b> year via the Faculty tab (Medical) after the faculty key is associated with the profile.",
  FACULTY_DATA_VERIFICATION_CRITERIA3 = "When CPP ownership is set for a faculty member as 'Selected' = Yes + Current <b>OR</b> Future Year.",
  FACULTY_DATA_VERIFICATION_CRITERIA4 = "When the <b>New/Existing Faculty is added in Medical Activity</b> having below:",
  FACULTY_DATA_VERIFICATION_CRITERIA5 = "1. Activity Status: Pending or Active <br /> 2. A contract with an end date that is after the Data Verification start date <br /> 3. With a Consultant Status:",
  FACULTY_DATA_VERIFICATION_CRITERIA6 = "Approved <br /> Pending Milestone Approval <br />Agreement/Amendment Sent <br />Fully Executed <br /> Pending Deviation <br />Pending Budget Approval <br /> Pending Screening<br />CV not received<br />CV received in review<br />Screening Under Review",
  ADD_EDIT_EXPENSE_DIALOG_TITLE = "Add/Edit Expense Exception",
  ADD_EDIT_SB_INDICATOR_DIALOG_TITLE = "Add/Edit SB Indicator/ Brand Rule",
  ADD_ORGANISATIONAL_CONTACTS = "Request to Add Organizational Contact",
  EDIT_PPQ_TITLE = "Edit PPQ",
  FACULTY_INTRODUCTORY_VIDEO_LABEL = "External viewers can access the introductory video by scanning the QR code found on printed and emailed invitations to faculty-led, brand-approved activities",
  FACULTY_INTRODUCTORY_SEND_TOOLTIP = "By clicking ‘Send,’ the system checks if the faculty member qualifies. If so, an email alert is sent, and alerts appear on the FR website under 'My Actions' and in the FR App under 'Pending Action Items.' The alert includes a link to Spokenote for video recording.",
  FACULTY_INTRODUCTORY_OPTOUT_TOOLTIP = "Opt-out from the introductory video recording by selecting this option. Re-enabled at any time by deselecting this option.",
  NO_PDF_FOUND = "No PDF Found",
  SAVE = "Save",
  FILTER_REQUESTER = "Requester",
  ASSOCIATE = "Associate",
  LEADER = "Leader",
  FACULTY_DATA_VERIFICATION = "Faculty Data Verification",
  HERE = " here ",
  NOTE = "Indicates that a field allocation exists within the brand allocation rule.",
  NOTE1 = "Indicates that there is a sub-allocation exists within the brand allocation rule.",
  DOWNLOAD_EXCEL_HOVER_TEXT = "This will download a spreadsheet that shows the faculty’s detailed compensation.  It will show all funds that are used, available, and allocated by brand, as well as allocations that are made for specific Divisions/Districts/Areas/Sales Representatives",
  VEEVA_WEBSITE_LINK = "http://veevanetwork.lilly.com",
  CONTACT_POPUP_TITLE = "View Contact Notes",
  BI_COMP_LIMIT_POPUP_TITLE = "BI - Lilly Alliance Compensation & Utilization",
  FDA_ALLOCATION_RULE_DIALOG_TITLE = "Add /Edit FDA Regulated Allocation Rule",
  ALLOCATION_DELETE_MESSAGE = "Do you want to inactivate the rule?",
  ALLOCATION_BREAKDOWN_DIALOG_TITLE = "Allocation Breakdown - ",
  ALLOCATION_BREAKDOWN_AVAILABLE = "Available Amount",
  ALLOCATION_BREAKDOWN_ALLOCATED = "Allocated Amount",
  ALLOCATION_BREAKDOWN_USED = "Used Amount",
  ALIGNMENT_RULES_DIALOG_TITLE = "Alignment Rules",
  FACULTY_VIDEO_CRITERIA_LABEL = "On $date$, the faculty introductory video email was initiated. However, regardless of opting back in or sending the alert, the faculty member does not yet meet the criteria for the Introductory Video email alert. Once the criteria are fulfilled, the system will send the email with instructions.",
  FACULTY_REQUEST_PROFILE = "facultyrequestprofile",
  REQUEST_FOR_FUNDS_TITLE = "Request For Funds",
  FILE_NOT_EXIST = "File not exist",
  NO_CREDENTIALS = "No Credentials",
  OCCURRED = "Occurred",
  ACTIVITYSATS_CANCELLED = "Cancelled",
  N_A = "N/A",
  ADDORG_CONTACT_DIALOG = "Thought Leader Relationship Contact",
  VIEW_CV_TITLE = "View CV",
  VIEW_BIO_TITLE = "View Bio",
  VIEW_PICTURE = "View Picture",
  CV_NOT_AVAILABLE = "CV not available",
  BIO_NOT_AVAILABLE = "Bio not available",
  CHANGEPASSWORDFROMEMAIL = "ChangePasswordFromEmail",
  PICTURE_NOT_AVAILABLE = "Picture not available",
  NOT_AVAILABLE = "Not Available",
  ADMIN_SUBMENU_TEXT = "Admin:",
  EMPTY_HTML = "<p><br></p>",
  AFFILIATE_LIST_STATUS = "0,1",
  AMERICA_NEW_YORK_TIMEZONE = "America/New_York",
  UPDATE_APPROVERS = "Update Approvers",
  APPROVER_FROM = "approverFrom",
  APPROVER_TO = "approverTo",
  MEDICAL_APPROVER_FROM = "medicalApproverFrom",
  DAILY_FREQUENCY_LABEL_REPORT_SCHEDULER = "This report will be generated every weekday and it will be emailed to the email address on file.",
  WEEKLY_FREQUENCY_LABEL_REPORT_SCHEDULER = "This report will be generated on $selectedDays$ of every week and it will be emailed to the email address on file.",
  MONTHLY_FREQUENCY_LABEL_REPORT_SCHEDULER = "This report will be generated on $selectedDays$ and it will be emailed to the email address on file.",
  DAY_OF_MONTHLY_LABEL_REPORT_SCHEDULER = "$day$ of every month",
  REPORTSCHEDULERCONSTANTS = "ReportSchedulerConstants",
  DAILY = "Daily",
  WEEKLY = "Weekly",
  MONTHLY = "Monthly",
  MEDICAL_APPROVER_TO = "medicalApproverTo",
  LEGAL_APPROVER_FROM = "legalApproverFrom",
  LEGAL_APPROVER_TO = "legalApproverTo",
  REGULATORY_APPROVER_FROM = "regulatoryApproverFrom",
  REGULATORY_APPROVER_TO = "regulatoryApproverTo",
  UPDATE_LEVELS = "updateLevels",
  BRANDS_ON_CONTRACT = "Brands on the Contract",
  CONTRACT_DEFINITION = "Contract Definition",
  ADD_TITLE = "Add",
  REMOVE_TITLE = "Remove",
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  CAMELCASE_INACTIVE = "InActive",
  MAX_THREE_FIFTY_CHARACTER = "350 character limit",
  ALIGNMENT_LIMITS_POPUP_MSG = "The Rule for the same combination already exists. Do you want to update the existing rule?",
  FIVE_MIN_API_TIMEOUT = 300000,
  FR_COORDINATOR_FACULTY_REQUEST_ALERT = 130,
  FIRST_AFTER_IMMEDIATE = 1,
  MAX_HUNDERD_CHARACTER = "(Note cannot exceed 100 characters)",
  CLIENT = "client",
  ADD_ARROWS_BUTTON_TEXT = "Add >>",
  REMOVE_ARROWS_BUTTON_TEXT = "<< Remove",
  PREVIEW = "Preview",
  BACK = "Back",
  YEAR_MONTH_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS",
  AUTOMATED_BUSINESS_TASK_SELECT_VALIDATION_MESSAGE = "Please select ",
  AUTOMATED_BUSINESS_TASK_ENTER_VALIDATION_MESSAGE = "Please enter the ",
  ATTACHMENT = "Attachment",
  LOGO = "Logo",
  TABLE_MERGE_FIELD_EXIST = " is already added.",
  Place_Holder_Text = "Please Select",
  MONTH_DATE_YEAR_FORMAT_WITHOUT_TIME = "MM/DD/YYYY",
  YEAR_MONTH_DATE_FORMAT_WITHOUT_TIME = "YYYY-MM-DD",
  AM = "AM",
  PM = "PM",
  ARROW_DOWN = "ArrowDown",
  ARROW_UP = "ArrowUp",
  CONTENT_MANGEMENT_PARENT_CPS = "CPS",
  CONTENT_MANGEMENT_PARENT_CPP = "CPP",
  CONTENT_MANGEMENT_PARENT_FR_RESOURCES = "FR - Resources",
  CONTENT_MANGEMENT_PARENT_FR_CONTENT = "FR - Content",
  ACTIVITY_DESCRIPTION_PARAMS = "activitydescription",
  ACTIVITY_POPUP_MESSAGE = "Are you sure this Activity Blocking Rule should be an Overarching Rule?",
  TIME_FORMAT = "HH:mm:ss.SSS",
  CPS_DATE_API_FORMAT = "YYYY-MM-DD'T'HH:mm:ss.SSS",
}

export enum GridNoRowsMessages {
  GRID_NO_MYLISTS_MSG = "There are no My Lists.",
  GRID_NO_ADDRESS_MSG = "There are no Address Type.",
  GRID_NO_ADDITIONAL_REQUESTOR_MSG = "There are no Addditional Requesters.",
  GRID_NO_QUESTIONNAIRE = "There are no Questionnaire.",
  GRID_NO_FACULITIES_MSG = "There are no Faculties.",
  GRID_NO_EXPENSE_EXCEPTIONS_MSG = "There are no Expense Exceptions.",
  GRID_NO_FACULTY_INTRODUCTORY_VIDEO_MSG = "There are no Faculty Introductory Video.",
  GRID_NO_FACULTY_Rules_MSG = "There are no Faculty Rules.",
  GRID_NO_DELEGATES_MSG = "There are no Delegates.",
  GRID_NO_CUSTOMER_MEETING_MSG = "There are no Customer Meeting Services Associate.",
  GRID_NO_THOUGHT_LEADER_MSG = "There are no Thought Leader Relationship Contact.",
  GRID_NO_ACTIVITY_STASISTICS = "There are no Activity Statistics.",
  GRID_NO_CONTRACTS_TRAINING = "There are no Contracts/Training.",
  GRID_NO_BRAND_TOPICS = "There are no Brand/Topics.",
  GRID_NO_TOPIC_INFO = "There are no Topic Info.",
  GRID_NO_POTENTIAL_CONFLICTS = "There are no Potential Scheduling Conflicts.",
  GRID_NO_ACTIVITIES = "There are no Activities.",
  GRID_NO_TAXFORM = "There are no Tax Forms.",
  GRID_NO_CONTACT_NOTES = "There are no Contact Notes.",
  GRID_NO_AFFILIATION = "There are no Affiliations.",
  GRID_NO_HCP_AFFILIATION = "There are no HCP Affiliation(s).",
  GRID_NO_VENUE_CATERER = "There are no Venue/Caterer.",
  GRID_NO_OPTIN_TRAVEL_DOCUMENT = "There are no Travel Documents.",

  GRID_NO_METADATA = "There are no Metadata details.",
  GRID_NO_AFFILIATION_MSG = "There are no Affiliation Lists.",
  GRID_NO_COMPLIANCE_QUEUE_MSG = "There are no Compliance Queue Lists.",
  GRID_NO_COMPLIANCE_RULES_MSG = "There are no Compliance Rule Lists.",
  GRID_NO_MEDICAL_DD_MSG = "There are no Medical DD Fields Lists.",
  GRID_NO_SUPPLIER_MSG = "There are no Supplier Lists.",
  GRID_NO_ENTITY_MSG = "There are no Entity Lists.",
  GRID_NO_HCP_MSG = "There are no HCP Lists.",
  GRID_NO_1099_INDIVIDUAL_MSG = "No records were found to Generate 1099 Individual Report.",
  GRID_NO_1099_CONTACT_NOTES = "There are Contact Notes.",
  GRID_NO_SUPPLIER_BRAND_RULE = "There are no Supplier Brand Rules.",
  GRID_NO_SUPPLIER_MAPPING = "There are no Supplier Mapping Lists.",
  GRID_NO_VMS_FACULTY = "There are no VMS Faculty Lists.",
  GRID_NO_ANNOUNCEMENT_EDITOR = "There are no Announcement Editor Lists.",
  GRID_NO_FIELD_LIST = "There are no Field Lists.",
  GRID_NO_BRAND_APPROVERS = "There are no Approvers List.",
  GRID_NO_SPONSOR_ASSIGNMENT_RULE = "There are no Sponsor Assignment Rule List.",
  GRID_NO_SPEAKER_PROGRAM_COMMENTS = "There are no Speaker Program Preferences Comments List.",
  GRID_NO_SPEAKER_PROGRAM_NOTIFICATION = "There are no Speaker Program Preferences Notification List.",
  GRID_NO_BRANDS = "There are no Brands List.",
  GRID_NO_SUB_BRANDS = "There are no SubBrands List.",
  GRID_NO_ANNUAL_CONFIG = "There are no Annual Config List.",
  GRID_NO_ACTIVITY_COST_CENTER_RULES = "There are no Activity Cost Center Rules List.",
  GRID_NO_TOPIC_CONFIG = "There are no Topics/Training Requirements Config List.",
  GRID_NO_FACULTY = "There are no Faculties List.",
  GRID_NO_ACTIVITY = "There are no Activities List.",
  GRID_NO_USERS = "There are no Users List.",
  GRID_NO_ADVISING_CENTRAL_MEMBERS = "There are no Advising Central Members Configuration comments.",
  GRID_NO_COMMENTS = "There are no Credentials for Payment Limits Comments.",
  GRID_NO_ACTIVITY_ASSIGNMENTS = "There are no Activity Assignment.",
  GRID_NO_CONTACT_NOTE_TYPE_CONFIG = "There are no Contact Note Type.",
  GRID_NO_TARGET_USERS = "There are no Target Users List.",
  GRID_NO_USER_GROUP = "There are no Users Group List.",
  GRID_NO_ALIGNEMENT_GROUP = "There are no Alignment List.",
  GRID_NO_ASSIGNER_ALIGNMENTS = "There are no Assigner Alignments List.",
  GRID_NO_POTENTIAL_DUPLICATES = "There are no Potential Duplicates",
  GRID_NO_TRAINING_REQUIREMENTS = "There are no Training requirements.",
  GRID_NO_FACULTY_SELECTIION_RULES = "There are no Faculty Selection Rules",
  GRID_NO_CREDENTIALS = "There are no Credentials and Specialties List.",
  GRID_NO_ALIGNMENT_LIMITS = "There are no Alignment Limits List.",
  GRID_NO_CONTACT_NOTES_MSG = "There are no Contact Notes.",
  GRID_NO_CONTRACT_MANAGEMENT_MSG = "There are no Contract Management List.",
  GRID_NO_CONTRACT_HISTORY_MSG = "There are no View Contract History List.",
  GRID_NO_GROUPING_CONFIGURATION_MSG = "There are no Grouping Configuration List.",
  GRID_NO_FACULTY_FOUND = "No Faculties were found.",
  GRID_NO_VIEW_HISTORY = "There are no View History List.",
  GRID_NO_COMMENTS_LIST = "There are no Comments List.",
  GRID_NO_CONTRACT_TEMPLATES = "There are no Contract Templates List.",
  GRID_NO_EXCLUDED_APPROVERS = "There are no Excluded Approvers List.",
  GRID_NO_USER_GROUP_MEMBERSHIP = "There are no User Group Membership List.",
  GRID_NO_STATE_GUIDELINES = "There are no State Guidelines List.",
  GRID_NO_INVITATION_TEMPLATES = "There are no Invitation Templates List.",
  GRID_NO_APPPROVAL_REQUIRED = "There are no Approval required List.",
  GRID_NO_REP_EVALUATION_CONFIG = "There are no Rep Evaluation Config List.",
  GRID_NO_EXPENSE_MANAGEMENT = "There are no Expense Management List.",
  GRID_NO_EXPENSE_CONTACT_NOTES_MSG = "There are no Expense Contact Notes.",
  GRID_NO_PROFILE_LIST = "There are no Profile List.",
  GRID_NO_RULE = "There are no Rule List.",
  GRID_NO_EMAIL_TEMPLATES = "There are no Email Templates List.",
  GRID_NO_BUDGET_EXEMPTION = "There are no Budget Exemption List.",
  GRID_NO_BUSINESS_JUSTIFICATION = "There are no Business Justification List.",
  GRID_NO_FACULTY_SELECTIION = "There are no Faculty Selection List.",
  GRID_NO_USER_GROUP_DIVISION_MAPPING = "There are no User Group & Division Mapping List.",
  GRID_NO_USER_MANAGEMENT = "There are no User Mangement Lists.",
  GRID_NO_TIER_BRAND_MAPPING = "There are no Tier Brand Mapping Lists.",
  GRID_NO_USER_MANAGEMENT_COMMENTS = "There are no Comment Lists.",
  GRID_NO_ACTIVITYCOMPLIANCE_EDITOR = "There are no Activity Compliance Lists.",
  GRID_NO_COMMENTHISTORY_EDITOR = "There are no Comment History.",
  GRID_NO_COMMENTS_EDITOR = "There are no Comments.",
  GRID_NO_USER_MANAGEMENT_FR_SEARCH = "There are no FR Lists.",
  GRID_NO_USER_MANAGEMENT_ALIGNMENT_SEARCH = "There are no Sales Force Lists.",
  GRID_NO_HONORARIUM_ADMIN = "There are no Honorarium Admin Lists.",
  GRID_NO_MERGE_FIELD_LIST = "There are no Merge Field Category List.",
  GRID_NO_SCREENING_ENTITY_LIST = "There are no Screening Entity List.",
  GRID_NO_ACTIVTY_RULE_LIST = "There are no Activity Rule List.",
}

export enum GenericProfileBreadCrumbs {
  PROFILE = 46,
  CONTACT_INFO = 47,
  TOPIC_INFO = 49,
  OPT_IN = 50,
  MISCELLANEOUS = 56,
  CV_BIO_PHOTO = 60,
  AFFILIATION_LICENSES = 87,
  TIERING = 91,
  TAX_FORMS = 104,
  SPEAKER_PROGRAM = 105,
  SUPPLIER_INFO = 106,
  USER_LIST = 107,
  COMMENTS = 108,
}

export enum OnOff {
  ON = "On",
  OFF = "Off",
}

export enum YesNo {
  YES = "Yes",
  NO = "No",
}

export enum ControlType {
  "textBox",
  "calendar",
  "dropDown",
  "multiSelect",
  "checkBox",
  "radioButton",
  "button",
  "label",
}

export enum FacultyAddressType {
  THIRD_PARTY_F = "3",
  ACADEMIC = "A",
  Clinical = "C",
  FINANCIAL = "F",
  HOME = "H",
  OFFICE = "O",
  PRACTICE = "P",
  UNSPECIFIED = "U",
}

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: CPSConstants.ITEM_HEIGHT * 4.5 + CPSConstants.ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export enum FacultyType {
  HCP = 1,
  PATIENT_CAREGIVER = 2,
  NON_HCP = 3,
}
export enum compTableColCells {
  "FDA Regulated",
  "Advising/Consulting",
  "Combined Funds(No Split)",
}
export enum RuleTypeId {
  COMBINED_RULE = 0,
  ADV = 1,
  FDA = 2,
}
export enum AllocationGrid {
  COMBINED = "COMBINED",
  ADV = "ADV",
  FDA = "FDA",
}
export enum RuleType {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
export const SyncFusionToolbarSettings: object = {
  type: ToolbarType.MultiRow,
  enableFloating: false,
  items: [
    "Bold",
    "Italic",
    "Underline",
    "StrikeThrough",
    "FontName",
    "FontSize",
    "FontColor",
    "BackgroundColor",
    "LowerCase",
    "UpperCase",
    "Formats",
    "Alignments",
    "OrderedList",
    "UnorderedList",
    "Outdent",
    "Indent",
    "CreateLink",
    "Image",
    "ClearFormat",
    "Print",
    "SourceCode",
    "FullScreen",
    "Undo",
    "Redo",
    "CreateTable",
  ],
};

export const SyncFusionQuickToolbarSettings: object = {
  image: [
    "Replace",
    "Align",
    "Caption",
    "Remove",
    "InsertLink",
    "OpenImageLink",
    "-",
    "EditImageLink",
    "RemoveImageLink",
    "Display",
    "AltText",
    "Dimension",
    "TableCell",
  ],
  link: ["Open", "Edit", "UnLink"],
  table: [
    "TableHeader",
    "TableRows",
    "TableColumns",
    "TableCell",
    "-",
    "BackgroundColor",
    "TableRemove",
    "TableCellVerticalAlign",
    "Styles",
  ],
};

export enum AlignmentRuleType {
  TERRITORY = "Territory",
  DISTRICT = "District",
  AREA = "Area",
  DIVISION = "Division",
}
export enum BrandRuleTypeId {
  RESERVE = "Reserve",
  LIMIT = "limit",
}
export enum breadCrumbIdsAddHCP {
  PROFILE = 29,
  CONTACTINFO = 30,
  SPONSORINFO = 31,
}
export enum subMenus {
  PROFILE = 29,
  CONTACTINFO = 30,
  SPONSORINFO = 31,
  SUPPLIER = 89,
}
export enum ActivitySubType {
  Unspecified = 0,

  Field = 1,

  Brand = 2,

  OUS = 3,

  Global = 4,

  Medical = 5,

  Future = 6,

  MarketingFDA = 7,

  MarketingAdvising = 8,

  Consulting = 9,
}
export enum DocumentTexts {
  UPDATEdOCUMENT = "Update Documents",
  UPLOADdOCUMENT = "Upload Documents",
  POPUPHEADERTEXT = "Document Type",
  POPUPHEADERDESC = "Browse and Upload Document",
  DOCUMENTNAME = "Document Name",
  UPDATETEXT = "Update",
  UPLOADTEXT = "Upload",
}

export enum AdminScreening {
  Entity = 2,
  HCP = 4,
}

export enum LoginType {
  Application = 1,
  LillyNetSSO = 2,
  OktaSSO = 3,
  MFA = 4,
}

export enum AlertTypeId {
  InvoiceApprovalAlert = 301,
  HonorariumAmountLoweredAlert = 10568,
  FADescriptionOfServiceApprovalAlert = 103,
  AdvActivityServiceApprovalAlertsPreviewOther = 108,
  AdvActivityServiceApprovalAlertsPreviewSingle = 183,
  AdvActivityServiceApprovalAlertsPreviewAdvBoard = 184,
  NonMedicalPersonnelApprovalAlertPreview = 98,
}

export const API_RESPONSE_KEYS: string[] = [
  "messageCode",
  "message",
  "isSuccessMessage",
  "isErrorMessage",
  "isValidationMessage",
];

export enum ContractTypeKey {
  EContract = 1,
  Print = 2,
}

export enum ActivityType {
  Advising = 1,
  FDA = 2,
  Medical = 3,
}

export enum ContractStatus {
  NotYetSent = 1,
  Sent = 2,
  Received = 3,
  Declined = 4,
  InValidatedSent = 5,
  InValidatedReceived = 6,
  OnHold = 7,
  PendingNegotiation = 8,
  ApprovalRequired = 9,
}

export enum DocumentTypeKey {
  CV = 1,
  Bio = 2,
  Photo = 3,
  AnnualFacultyContract = 4,
  OfficeVisitAgreement = 5,
  MasterServiceAgreement = 6,
  RequestForService = 7,
  Addendum = 8,
  AdvisingDeviationForm = 9,
  ActivityContract = 10,
  SignInSheet = 11,
  W9 = 12,
  HardCopy = 13,
  Electronic = 14,
  USGeneralConsultingContract = 15,
  Amendment = 16,
  DMCContract = 17,
  Termination = 18,
  FDAVarianceForm = 19,
  Individual = 20,
  ThirdrdPartyPayee = 21,
  Exempt = 22,
  NonHCPContract = 23,
  PatientCaregiverContract = 24,
}

export enum UserManagementUserType {
  FACULTY = 1,
  NON_FACULTY = 2,
  STANDARD = 3,
  ADVANCE = 5,
  CPP_ADMIN = 6,
  SALES_FORCE = 7,
  NON_SALES_FORCE = 8,
  FR_DELEGATE_STANDARD = 9,
}

export enum UserManagementMFAType {
  MOBILE = 2,
  EMAIL = 1,
}

export enum UserManagementSystemId {
  CPS = 1,
  CPP = 2,
  FR = 3,
}

export enum UserManagementUserStatusId {
  INACTIVE = 0,
  ACTIVE = 1,
  PENDING = 2,
  NOT_APPROVE = 4,
}

export enum UserManagementSalesForceInfoModule {
  AREA = "A",
  DISTRICT = "D",
  TERRITORY = "T",
}

export enum UserManagementSalesForceInfoLabel {
  AREA = "Area",
  DISTRICT = "District",
  TERRITORY = "Territory",
}

export enum ProgramTypes {
  FIELD_PROGRAM = 1,
  BRAND_FDA = 2,
}

export const AttachmentFileExtensionArray = [
  ".doc",
  ".docx",
  ".rtf",
  ".xls",
  ".xlsx",
  ".pdf",
  ".ppt",
  ".pptx",
  ".txt",
];
export const LogoFileExtensionArray = [".png", ".jpeg", ".jpg", ".gif", ".bmp"];

export const NOT_SUPPORTTED_FILE_EXTENSION = [
  "ASP",
  "PHP",
  "JSP",
  "EXE",
  "HTML",
  "PHP5",
  "PHT",
  "PHTML",
  "SHTML",
  "ASA",
  "CER",
  "ASAX",
  "SWF",
  "XAP",
];

export const BASE64EXTN = "data:application/octet-stream;base64,";

export enum RuleTypes {
  PLEASE_SELECT = -1,
  BLOCKING = 1,
  LIMITING = 2,
  SALESFORCE_TRAINING_AND_PERMISSIONING = 3,
  LICENSING = 4,
  CONTRACT_APPROVAL_REQUIRED = 5,
}

//To do reportscheduler
export enum ReportSchedulerBtn {
  Submit = "submit",
  Delete = "delete",
  Cancel = "Cancel",
}

export const ReportSchedulerConstants: {
  months: string[];
  workingDays: string[];
} = {
  months: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ],
  workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
};
